module.exports = __webpack_public_path__ + "static/media/spade.145169a9.svg";